document.addEventListener("DOMContentLoaded", function () {

  const app = document.getElementById("tsb-rechner-app--tsb");
  const output = document.getElementById("tsb-price-sticky--tsb");

  if (!app || !output) return;
  const DEV_MODE =
  new URLSearchParams(window.location.search)
    .get("tsb_debug_key") === "TSBGmbH*1417";
    const minimumQuantity = DEV_MODE ? 10 : 100;

  // =========================
  // WAIT FOR DATA (SAFE)
  // =========================
  function getData() {
    return window.TSB_PRICE_DATA || null;
  }

  function waitForData(callback) {
    const check = () => {
      const DATA = getData();
      if (DATA) return callback(DATA);
      setTimeout(check, 50);
    };
    check();
  }

  // =========================
  // INIT
  // =========================
  waitForData(function (DATA) {

    let state = {
      product: "gildan-g5000",
      quantity: minimumQuantity,
      textile_color: "white",
      custom_ek: {
        white: 0,
        color: 0
      },
      custom_factor: {
        enabled: false,
        value: 2.5
      },
      positions: {
        front: 0,
        back: 0,
        sleeve_left: 0,
        sleeve_right: 0
      }
    };

    // =========================
    // UI
    // =========================
    app.innerHTML = `
      <div style="
          display:flex;
          flex-direction:column;
          gap:16px;
          max-width:520px;
          margin:10px auto 48px;
          padding:24px;
          background:#ffffff;
          border:1px solid #e5e7eb;
          border-radius:18px;
          box-shadow:
          0 18px 42px rgba(15,23,42,0.08),
          0 1px 0 rgba(255,255,255,0.6) inset;
        ">

        <style>
          #tsb-rechner-app--tsb label {
            font-size:12px;
            font-weight:700;
            color:#374151;
            margin-bottom:-6px;
          }

          #tsb-rechner-app--tsb input,
          #tsb-rechner-app--tsb select {
            width:100%;
            min-height:44px;
            padding:10px 12px;
            border:1px solid #d1d5db;
            border-radius:10px;
            background:#ffffff;
            color:#111827;
            font-size:14px;
            outline:none;
            box-sizing:border-box;
          }

          #tsb-rechner-app--tsb select {
            appearance:none;
            -webkit-appearance:none;
            padding-right:42px;
            background-image:
              linear-gradient(45deg, transparent 50%, #64748b 50%),
              linear-gradient(135deg, #64748b 50%, transparent 50%);
            background-position:
              calc(100% - 20px) 50%,
              calc(100% - 14px) 50%;
            background-size:
              6px 6px,
              6px 6px;
            background-repeat:no-repeat;
          }

          @media (max-width: 640px) {
            #tsb-rechner-app--tsb .tsb-print-grid--tsb,
            #tsb-rechner-app--tsb .tsb-qty-textile-grid--tsb,
            #tsb-rechner-app--tsb .tsb-custom-grid--tsb,
            #tsb-price-sticky--tsb .tsb-tier-grid--tsb,
            #tsb-price-sticky--tsb .tsb-debug-grid--tsb {
              grid-template-columns:1fr !important;
            }
          }

          #tsb-rechner-app--tsb input,
          #tsb-rechner-app--tsb select {
            transition:border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
          }

          #tsb-rechner-app--tsb .tsb-card--tsb {
            transition:
              transform 0.22s ease,
              box-shadow 0.22s ease,
              border-color 0.22s ease;
          }

          #tsb-rechner-app--tsb .tsb-card--tsb:hover {
            transform:translateY(-2px);
            box-shadow:0 14px 30px rgba(15,23,42,0.08);
            border-color:#dbe4ee;
          }

          #tsb-rechner-app--tsb input:hover,
          #tsb-rechner-app--tsb select:hover {
            border-color:#94a3b8;
          }

          #tsb-rechner-app--tsb input:focus,
          #tsb-rechner-app--tsb select:focus {
            border-color:#009ee0;
            box-shadow:0 0 0 3px rgba(0,158,224,0.14);
          }
        </style>

        <div class="tsb-card--tsb" style="
          padding:16px;
          border:1px solid #e5e7eb;
          border-radius:16px;
          background:#f8fafc;
        ">

          <div style="
            font-size:13px;
            font-weight:900;
            color:#0f172a;
            margin-bottom:12px;
          ">
            Produkt & Menge
          </div>

          <label>Produkt</label>
        <select id="tsb-product--tsb">

          ${DATA.textiles.categories
          .sort((a, b) => (a.priority || 999) - (b.priority || 999))
          .map(c => `
            <optgroup label="${c.name.de}">
              ${c.products.map(p =>
                `<option value="${p.id}">${p.brand} — ${p.name.de}</option>`
              ).join("")}
            </optgroup>
          `).join("")}

        ${DEV_MODE ? `
          <option value="__custom">🛠 Freier Artikel (DEBUG)</option>
        ` : ``}

        </select>

        <div class="tsb-qty-textile-grid--tsb" style="
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:12px;
          margin-top:12px;
        ">
          <div>
            <label>Menge</label>
            <input id="tsb-qty--tsb" type="number" value="${minimumQuantity}" min="${minimumQuantity}">

            <div style="
              margin-top:6px;
              font-size:11px;
              line-height:1.4;
              color:#64748b;
            ">
              Mindestmenge: ${minimumQuantity} Stück
            </div>
          </div>

          <div>
            <label>Textilfarbe</label>
            <select id="tsb-textile--tsb">
              <option value="white">Weiß</option>
              <option value="color">Farbig</option>
            </select>
          </div>
        </div>

        </div>
        
        ${DEV_MODE ? `
        <div id="tsb-custom-ek-fields--tsb" style="
          display:none;
          padding:16px;
          border:1px solid #bae6fd;
          border-radius:16px;
          background:#f0f9ff;
        ">

          <div style="
            font-size:13px;
            font-weight:900;
            color:#075985;
            margin-bottom:12px;
          ">
            Interner Freier Artikel
          </div>

          <div class="tsb-custom-grid--tsb" style="
            display:grid;
            grid-template-columns:1fr 1fr;
            gap:12px;
          ">
            <div>
              <label>EK Weiß</label>
              <input id="tsb-custom-ek-white--tsb" type="number" step="0.01" value="0">
            </div>

            <div>
              <label>EK Farbig</label>
              <input id="tsb-custom-ek-color--tsb" type="number" step="0.01" value="0">
            </div>
          </div>

        </div>
      ` : ``}

      ${DEV_MODE ? `
      <div id="tsb-custom-factor-fields--tsb" style="
        padding:16px;
        border:1px solid #fde68a;
        border-radius:16px;
        background:#fffbeb;
      ">

        <div style="
          font-size:13px;
          font-weight:900;
          color:#92400e;
          margin-bottom:12px;
        ">
          Interner Faktor
        </div>

        <label style="
          display:flex;
          align-items:center;
          gap:8px;
          margin-bottom:12px;
          cursor:pointer;
        ">
          <input
            id="tsb-custom-factor-enabled--tsb"
            type="checkbox"
            style="
              width:auto;
              min-height:auto;
              margin:0;
            "
          >
          Faktor überschreiben
        </label>

        <div>
          <label>Eigener Faktor</label>
          <input
            id="tsb-custom-factor-value--tsb"
            type="number"
            step="0.01"
            min="0"
            value="2.50"
            disabled
          >
        </div>

      </div>
      ` : ``}

       <div class="tsb-card--tsb" style="
          padding:16px;
          border:1px solid #e5e7eb;
          border-radius:16px;
          background:#f8fafc;
        ">

          <div style="
            font-size:13px;
            font-weight:900;
            color:#0f172a;
            margin-bottom:12px;
          ">
            Druckpositionen
            <div style="
              margin-top:6px;
              margin-bottom:14px;
              font-size:12px;
              font-weight: 600;
              line-height:1.5;
              color:#64748b;
            ">
              Bitte geben Sie je Druckposition die Anzahl der sichtbaren Druckfarben an.<br>
              <span style="
                color:#475569;
                font-size:13px;
                font-weight:600;
              ">
                0 = kein Druck · 1–12 = sichtbare Druckfarben.
              </span>
              Bei farbigen Textilien wird das notwendige Unterbase-Weiß automatisch berücksichtigt.
            </div>
          </div>

          <div class="tsb-print-grid--tsb" style="
              display:grid;
              grid-template-columns:1fr 1fr;
              gap:12px;
            ">

              <div>
                <label>Vorderseite (Farben)</label>
                <input data-pos="front" type="number" value="0" min="0" placeholder="0 = kein Druck">
              </div>

              <div>
                <label>Rückseite (Farben)</label>
                <input data-pos="back" type="number" value="0" min="0" placeholder="0 = kein Druck">
              </div>

              <div>
                <label>Linker Ärmel (Farben)</label>
                <input data-pos="sleeve_left" type="number" value="0" min="0" placeholder="0 = kein Druck">
              </div>

              <div>
                <label>Rechter Ärmel (Farben)</label>
                <input data-pos="sleeve_right" type="number" value="0" min="0" placeholder="0 = kein Druck">
              </div>

            </div>

          </div>

      </div>
    `;

    // =========================
    // CALC FUNCTIONS (DIRECT, NO ENGINE)
    // =========================

    function getTextilePrice() {
      if (state.product === "__custom") {
        return state.textile_color === "color"
          ? state.custom_ek.color
          : state.custom_ek.white;
      }

      for (const c of DATA.textiles.categories) {
        const p = c.products.find(x => x.id === state.product);
        if (p) {
          return state.textile_color === "color"
            ? p.ek.color
            : p.ek.white;
        }
      }
      return 0;
    }
    function getPrintPrice(colors, qty) {

      const tiers = Object.keys(DATA.print.matrix)
        .map(Number)
        .sort((a, b) => a - b);

      let selected = tiers[0];

      for (const t of tiers) {
        if (qty >= t) selected = t;
      }

      return DATA.print.matrix[selected]?.[colors] || 0;
    }

    function calculatePrint() {

      let total = 0;

      for (const c of Object.values(state.positions)) {
        if (c > 0) {
          const colors = state.textile_color === "color" ? c + 1 : c;
          total += getPrintPrice(colors, state.quantity);
        }
      }

      return total;
    }

    function getSetup() {
      let setupColors = 0;

      for (const c of Object.values(state.positions)) {
        if (c > 0) {
          setupColors += state.textile_color === "color" ? c + 1 : c;
        }
      }

      return setupColors * DATA.setup.price_per_color;
    }

    function getNK() {
      return state.quantity * DATA.nk.per_piece;
    }

    // ===============================
    // PATCH START: PRICE FORMATTER
    // ===============================
    function formatPrice(value) {
      return Number(value).toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
    // ===============================
    // PATCH END: PRICE FORMATTER
    // ===============================

    function getFactor() {
      if (
        DEV_MODE &&
        state.custom_factor.enabled &&
        Number.isFinite(state.custom_factor.value) &&
        state.custom_factor.value > 0
      ) {
        return state.custom_factor.value;
      }

      let f = DATA.factor.tiers[0].value;

      for (const t of DATA.factor.tiers) {
        if (state.quantity >= t.min) f = t.value;
      }

      return f;
    }

    function getTierHint(quantity, state, DATA, getTextilePrice, calculatePrint, getFactor) {

      const tiers = DATA.factor.tiers.map(t => t.min).sort((a, b) => a - b);

      let nextTier = null;

      for (const t of tiers) {
        if (t > quantity) {
          nextTier = t;
          break;
        }
      }

      if (!nextTier) return "";

      const diff = nextTier - quantity;

      const textile = getTextilePrice();
      const print = calculatePrint();
      const factor = getFactor();

      const colors =
        state.positions.front +
        state.positions.back +
        state.positions.sleeve_left +
        state.positions.sleeve_right;

      const base = (textile + print) * nextTier;
      const production = base * factor;

      const setup = getSetup();
      const nk = nextTier * 0.09;

      const nextTotal = production + setup + nk;
      const nextUnit = nextTotal / nextTier;

      return `
        <div style="margin-top:14px;padding:12px;border-radius:10px;background:linear-gradient(135deg,#009ee0,#007bb8);color:white;font-size:12px;">
          <strong>💡 Staffelvorteil möglich</strong><br>
          +${diff} Stück → nächste Preisstaffel aktiv<br>
          Neuer Stückpreis: ${nextUnit.toFixed(2)} €
        </div>
      `;
    }

    // =========================
    // RENDER
    // =========================
    function render() {

      // =========================
      // 1. BASISWERTE
      // =========================
      const textile = getTextilePrice();
      const print = calculatePrint();
      const quantity = state.quantity;

      const tiers = DATA.factor.tiers.map(t => t.min).sort((a,b)=>a-b);

      let nextTier = null;

      for (const t of tiers) {
        if (t > quantity) {
          nextTier = t;
          break;
        }
      }

      let tierHint = "";

      const colors = Object.values(state.positions)
        .filter(v => v > 0).length + (state.textile_color === "color" ? 1 : 0);

      const factor = getFactor();

      tierHint = getTierHint(quantity, state, DATA, getTextilePrice, calculatePrint, getFactor);

      const hasPrintPosition =
      state.positions.front > 0 ||
      state.positions.back > 0 ||
      state.positions.sleeve_left > 0 ||
      state.positions.sleeve_right > 0;

      const printEkDetails = [
        state.positions.front > 0 ? `[ F: ${formatPrice(getPrintPrice(state.textile_color === "color" ? state.positions.front + 1 : state.positions.front, state.quantity))} ]` : "",
        state.positions.back > 0 ? `[ B: ${formatPrice(getPrintPrice(state.textile_color === "color" ? state.positions.back + 1 : state.positions.back, state.quantity))} ]` : "",
        state.positions.sleeve_right > 0 ? `[ R: ${formatPrice(getPrintPrice(state.textile_color === "color" ? state.positions.sleeve_right + 1 : state.positions.sleeve_right, state.quantity))} ]` : "",
        state.positions.sleeve_left > 0 ? `[ L: ${formatPrice(getPrintPrice(state.textile_color === "color" ? state.positions.sleeve_left + 1 : state.positions.sleeve_left, state.quantity))} ]` : ""
      ].filter(Boolean).join(" ");

      const printDetails = [
        state.positions.front > 0 ? `Vorderseite: ${state.positions.front} ${state.positions.front === 1 ? "Farbe" : "Farben"}` : "",
        state.positions.back > 0 ? `Rückseite: ${state.positions.back} ${state.positions.back === 1 ? "Farbe" : "Farben"}` : "",
        state.positions.sleeve_left > 0 ? `Linker Ärmel: ${state.positions.sleeve_left} ${state.positions.sleeve_left === 1 ? "Farbe" : "Farben"}` : "",
        state.positions.sleeve_right > 0 ? `Rechter Ärmel: ${state.positions.sleeve_right} ${state.positions.sleeve_right === 1 ? "Farbe" : "Farben"}` : ""
      ].filter(Boolean).join("<br>");

      let productName = "Freier Artikel";

      for (const c of DATA.textiles.categories) {
        const p = c.products.find(x => x.id === state.product);

        if (p) {
          productName = `${p.brand} — ${p.name.de}`;
          break;
        }
      }

      const tierBoost = (() => {

      const nextTier = (() => {
        const tiers = DATA.factor.tiers.map(t => t.min).sort((a,b)=>a-b);

        for (const t of tiers) {
          if (t > quantity) return t;
        }
        return null;
      })();

      if (!nextTier) return "";

      const distance = nextTier - quantity;
      const ratio = distance / nextTier;

      const textile = getTextilePrice();

      let print = 0;
      for (const c of Object.values(state.positions)) {
        if (c > 0) {
          const colors = state.textile_color === "color" ? c + 1 : c;
          print += getPrintPrice(colors, nextTier);
        }
      }

      let nextFactor = DATA.factor.tiers[0].value;
      for (const t of DATA.factor.tiers) {
        if (nextTier >= t.min) nextFactor = t.value;
      }

      const base = (textile + print) * nextTier;
      const production = base * nextFactor;

      const setup = getSetup();

      const nk = nextTier * 0.09;

      // ===============================
      // PATCH START: RESTORE NEXT TOTAL
      // ===============================
      const nextTotal = production + setup + nk;
      // ===============================
      // PATCH END: RESTORE NEXT TOTAL
      // ===============================

      const nextUnit = nextTotal / nextTier;

      // 🔵 STUFE 0 – zu weit weg
      if (ratio > 0.25) return "";

      // 🟡 STUFE 1 – Hinweis
      if (ratio > 0.15) {
        return `
          <div style="margin-top:12px;padding:12px;border-radius:10px;background:#1f2937;color:#fff;">
            💡 Preisvorteil ab ${nextTier} Stück
          </div>
        `;
      }

      // 🔴 STUFE 2 – Conversion Push

      // ===============================
      // PATCH START: UPGRADED TIER UI
      // ===============================

      // ===============================
      // PATCH START: FIX MISSING CURRENTUNIT
      // ===============================
      const currentPrint = calculatePrint();
      const currentBase = (textile + currentPrint) * quantity;
      const currentProduction = currentBase * factor;

      const currentSetup = getSetup();

      const currentNk = quantity * DATA.nk.per_piece;
      const currentTotal = currentProduction + currentSetup + currentNk;
      const currentUnit = currentTotal / quantity;
      // ===============================
      // PATCH END: FIX MISSING CURRENTUNIT
      // ===============================

      const currentDisplayUnit = Number(currentUnit.toFixed(2));
      const currentDisplayTotal = currentDisplayUnit * quantity;

      const nextDisplayUnit = Number(nextUnit.toFixed(2));
      const nextDisplayTotal = nextDisplayUnit * nextTier;

      const savingsTotal = Math.max(currentDisplayTotal - nextDisplayTotal, 0);

      const nextPriceFormatted = nextUnit.toFixed(2);
      const savingsFormatted = savingsTotal.toFixed(2);

      return `
        <div style="
          margin-top:10px;
          padding:16px;
          border-radius:18px;
          background:linear-gradient(135deg,#82b419 0%,#6a9614 100%);
          color:#fff;
          box-shadow:0 14px 32px rgba(130,180,25,0.24);
        ">

          <div style="
            display:flex;
            align-items:center;
            gap:10px;
            margin-bottom:10px;
            font-size:15px;
            font-weight:900;
          ">
            <span style="font-size:20px;">🚀</span>
            <span>Fast erreicht!</span>
          </div>

          <div style="
            font-size:13px;
            line-height:1.45;
            color:rgba(255,255,255,0.88);
            margin-bottom:14px;
          ">
            Nur noch <strong>${distance} Stück</strong> bis zur nächsten Preisstaffel.
          </div>

          <div class="tsb-tier-grid--tsb" style="
              display:grid;
              grid-template-columns:1fr 1fr;
              gap:10px;
            ">
            <div style="
              padding:12px;
              border-radius:14px;
              background:rgba(255,255,255,0.12);
              backdrop-filter:blur(8px);
            ">
              <div style="font-size:11px;text-transform:uppercase;letter-spacing:0.06em;color:rgba(255,255,255,0.72);">
                Neuer Stückpreis
              </div>
              <div style="margin-top:4px;font-size:20px;font-weight:900;">
                ${nextPriceFormatted} €
              </div>
            </div>

            <div style="
              padding:12px;
              border-radius:14px;
              background:rgba(255,255,255,0.12);
              backdrop-filter:blur(8px);
            ">
              <div style="font-size:11px;text-transform:uppercase;letter-spacing:0.06em;color:rgba(255,255,255,0.72);">
                Gesamtersparnis
              </div>
              <div style="margin-top:4px;font-size:20px;font-weight:900;">
                ${savingsFormatted} €
              </div>
            </div>
          </div>

        </div>
      `;
      // ===============================
      // PATCH END: UPGRADED TIER UI
      // ===============================

    })();

      // =========================
      // 2. PRODUKTION (SKALIERT)
      // =========================
      const base = (textile + print) * quantity;
      const production = base * factor;

      const baseTextileTotal = textile * quantity;
      const basePrintTotal = print * quantity;

      // =========================
      // 3. FIXKOSTEN
      // =========================
      const setup = getSetup();
      const setupUnits = Math.round(setup / DATA.setup.price_per_color);

      // =========================
      // 4. VARIABELE KOSTEN
      // =========================
      const nk = quantity * 0.09;

      // =========================
      // 5. TOTAL
      // =========================
      const total = production + setup + nk;
      const unit = total / quantity;

      // ===============================
      // PATCH START: DISPLAY TOTAL FIX
      // ===============================
      const displayUnit = Math.round(unit * 100) / 100;
      const displayTotal = Math.round(displayUnit * quantity * 100) / 100;
      // ===============================
      // PATCH END: DISPLAY TOTAL FIX
      // ===============================

      // =========================
      // 6. DEBUG EK
      // =========================
      const textileEK = textile * quantity;
      const printEK = print;
      const printEK_total = print * quantity;

      const ekTotal = textileEK + printEK_total + setup + nk;
      const nettoGewinn = total - ekTotal;

      const marge = total > 0 ? (nettoGewinn / total) * 100 : 0;

      // =========================
      // OUTPUT
      // =========================

      if (!hasPrintPosition) {
        output.innerHTML = `
          <div style="
            padding:20px;
            border-radius:18px;
            background:#eff6ff;
            border:1px solid #bfdbfe;
            color:#1e40af;
            font-size:14px;
            line-height:1.5;
            box-shadow:0 10px 24px rgba(15,23,42,0.06);
            text-align: center;
          ">
            💡 Wählen Sie mindestens eine Druckposition aus, um Ihren Preis zu berechnen.
          </div>
        `;
        return;
      }

      output.innerHTML = `
        <div style="
          background:
          linear-gradient(
            135deg,
            rgba(255,255,255,0.05) 0%,
            rgba(255,255,255,0.00) 22%
          ),
          radial-gradient(
            circle at top right,
            rgba(255,255,255,0.12),
            transparent 30%
          ),
          linear-gradient(
            135deg,
            #0f172a 0%,
            #1e293b 100%
          );
          border-radius:20px;
          padding:24px;
          color:#fff;
          box-shadow:
          0 22px 50px rgba(15,23,42,0.22),
          0 0 0 1px rgba(255,255,255,0.04) inset;
          margin-bottom:14px;
        ">

          <div style="
            font-size:13px;
            font-weight:700;
            letter-spacing:0.08em;
            text-transform:uppercase;
            color:rgba(255,255,255,0.72);
            margin-bottom:10px;
          ">
            Stückpreis
          </div>

          <div style="
            font-size:48px;
            line-height:1;
            font-weight:900;
            letter-spacing:-0.04em;
          ">
            ${formatPrice(unit)} €
          </div>

          <div style="
            margin-top:6px;
            font-size:14px;
            color:rgba(255,255,255,0.72);
          ">
            netto / Stück*
          </div>

          <div style="
            margin-top:18px;
            font-size:14px;
            font-weight:700;
            color:rgba(255,255,255,0.88);
          ">
            ${productName}
          </div>

          <div style="
            display:flex;
            gap:8px;
            margin-top:18px;
            flex-wrap:wrap;
          ">

            <span style="
              padding:6px 10px;
              border-radius:999px;
              background:rgba(255,255,255,0.12);
              backdrop-filter:blur(6px);
              font-size:12px;
              font-weight:700;
            ">
              ${quantity} Stück
            </span>

            <span style="
              padding:6px 10px;
              border-radius:999px;
              background:rgba(255,255,255,0.12);
              backdrop-filter:blur(6px);
              font-size:12px;
              font-weight:700;
            ">
              ${state.textile_color === "color" ? "Farbig" : "Weiß"}
            </span>

          </div>

          <div style="
            margin-top:22px;
            padding:12px;
            border-radius:14px;
            background:rgba(255,255,255,0.08);
            border:1px solid rgba(255,255,255,0.10);
          ">

            <div style="
              font-size:11px;
              font-weight:800;
              letter-spacing:0.08em;
              text-transform:uppercase;
              color:rgba(255,255,255,0.62);
              margin-bottom:6px;
            ">
              Druckdetails
            </div>

            <div style="
              font-size:13px;
              line-height:1.5;
              color:rgba(255,255,255,0.88);
            ">
              ${printDetails}
            </div>

          </div>

          <div style="
            margin-top:22px;
            padding-top:18px;
            border-top:1px solid rgba(255,255,255,0.12);
          ">

            <div style="
              font-size:13px;
              color:rgba(255,255,255,0.72);
              margin-bottom:4px;
            ">
              Gesamtprojekt netto*
            </div>

            <div style="
              font-size:34px;
              font-weight:900;
              letter-spacing:-0.03em;
            ">
              ${formatPrice(displayTotal)} €
            </div>

            <div style="
              margin-top:14px;
              padding-top:14px;
              border-top:1px solid rgba(255,255,255,0.12);
              font-size:11px;
              line-height:1.45;
              color:rgba(255,255,255,0.62);
            ">
              * Unverbindliche Kalkulation zzgl. gesetzlicher MwSt. Der finale Preis kann je nach Motiv, Druckdaten und Produktionsfreigabe abweichen.
            </div>

          </div>

        </div>

        ${DEV_MODE ? `
        <div style="
          margin-top:18px;
          padding:20px;
          border-radius:18px;
          background:#ffffff;
          border:1px solid #e5e7eb;
          box-shadow:0 10px 24px rgba(15,23,42,0.06);
        ">

          <div style="
            display:flex;
            justify-content:space-between;
            align-items:center;
            margin-bottom:18px;
          ">
            <div style="
              font-size:13px;
              font-weight:900;
              letter-spacing:0.08em;
              text-transform:uppercase;
              color:#0f172a;
            ">
              Prüfmodus
            </div>

            <div style="
              padding:6px 10px;
              border-radius:999px;
              background:#eff6ff;
              color:#0369a1;
              font-size:12px;
              font-weight:800;
            ">
              Faktor x${factor}
            </div>
          </div>

          <div class="tsb-debug-grid--tsb" style="
            display:grid;
            grid-template-columns:1fr 1fr;
            gap:10px;
            font-size:13px;
          ">

            <div style="padding:12px;border-radius:12px;background:#f8fafc;">
              <div style="color:#64748b;font-size:11px;">BASE</div>
              <div style="margin-top:4px;font-weight:800;color:#0f172a;">
                ${formatPrice(base)} €
                <span style="font-size:11px;color:#64748b;font-weight:600;position:relative;top:-1px;left:3px;">
                  [ T: ${formatPrice(baseTextileTotal)} ] [ D: ${formatPrice(basePrintTotal)} ]
                </span>
              </div>
            </div>

            <div style="padding:12px;border-radius:12px;background:#f8fafc;">
              <div style="color:#64748b;font-size:11px;">PRODUKTION</div>
              <div style="margin-top:4px;font-weight:800;color:#0f172a;">${formatPrice(production)} €</div>
            </div>

            <div style="padding:12px;border-radius:12px;background:#f8fafc;">
              <div style="color:#64748b;font-size:11px;">DRUCK EK / STK</div>
              <div style="margin-top:4px;font-weight:800;color:#0f172a;">
                ${formatPrice(print)} €
                <span style="font-size:11px;color:#64748b;font-weight:600;position:relative;top:-1px;left:3px;">
                  ${printEkDetails}
                </span>
              </div>
            </div>

            <div style="padding:12px;border-radius:12px;background:#f8fafc;">
              <div style="color:#64748b;font-size:11px;">TEXTIL EK / STK</div>
              <div style="margin-top:4px;font-weight:800;color:#0f172a;">${formatPrice(textile)} €</div>
            </div>

            <div style="padding:12px;border-radius:12px;background:#f8fafc;">
              <div style="color:#64748b;font-size:11px;">SETUP</div>
              <div style="margin-top:4px;font-weight:800;color:#0f172a;">
                ${formatPrice(setup)} €
                <span style="font-size:11px;color:#64748b;font-weight:600;position:relative;top:-1px;left: 3px;">
                  [ ${setupUnits} ]
                </span>
              </div>
            </div>

            <div style="padding:12px;border-radius:12px;background:#f8fafc;">
              <div style="color:#64748b;font-size:11px;">NK</div>
              <div style="margin-top:4px;font-weight:800;color:#0f172a;">${formatPrice(nk)} €</div>
            </div>

          </div>

          <div style="
            margin-top:18px;
            padding-top:18px;
            border-top:1px solid #e5e7eb;
          ">

            <div style="
              display:flex;
              justify-content:space-between;
              align-items:center;
              margin-bottom:10px;
              font-size:14px;
            ">
              <span style="color:#64748b;">TOTAL EK</span>
              <strong style="color:#0f172a;">
                ${formatPrice(ekTotal)} €
              </strong>
            </div>

            <div style="
              display:flex;
              justify-content:space-between;
              align-items:center;
              margin-bottom:10px;
              font-size:15px;
              font-weight:900;
              color:#15803d;
            ">
              <span>NETTO-GEWINN</span>
              <span>${formatPrice(nettoGewinn)} €</span>
            </div>

            <div style="
              display:flex;
              justify-content:space-between;
              align-items:center;
              font-size:14px;
            ">
              <span style="color:#64748b;">MARGE</span>
              <strong style="color:#0f172a;">
                ${formatPrice(marge)} %
              </strong>
            </div>

          </div>

        </div>
        ` : ``}
        
        ${typeof tierBoost === "string" ? tierBoost : ""}

        ${!tierBoost ? `
        <div style="margin-top:10px;font-size:12px;color:#999;">
          Aktuell bester Staffelpreis erreicht.
        </div>
      ` : ``}

      `;
    }

    // =========================
    // BIND
    // =========================
    function bind() {

      const select = app.querySelector("#tsb-product--tsb");
      const qty = app.querySelector("#tsb-qty--tsb");
      const textile = app.querySelector("#tsb-textile--tsb");

      const customWhite = app.querySelector("#tsb-custom-ek-white--tsb");
      const customColor = app.querySelector("#tsb-custom-ek-color--tsb");
      const customFactorEnabled = app.querySelector("#tsb-custom-factor-enabled--tsb");
      const customFactorValue = app.querySelector("#tsb-custom-factor-value--tsb");

      if (customFactorEnabled && customFactorValue) {
        customFactorEnabled.onchange = e => {
          state.custom_factor.enabled = e.target.checked;
          customFactorValue.disabled = !e.target.checked;
          render();
        };

        customFactorValue.oninput = e => {
          const val = parseFloat(String(e.target.value).replace(",", "."));

          if (Number.isFinite(val) && val > 0) {
            state.custom_factor.value = val;
          }

          render();
        };
      }

      if (customWhite) {
        customWhite.oninput = e => {
          const val = parseFloat(String(e.target.value).replace(",", "."));
          state.custom_ek.white = Number.isFinite(val) ? val : 0;
          render();
        };
      }

      if (customColor) {
        customColor.oninput = e => {
          const val = parseFloat(String(e.target.value).replace(",", "."));
          state.custom_ek.color = Number.isFinite(val) ? val : 0;
          render();
        };
      }

      select.onchange = e => {
        state.product = e.target.value;

        const customFields = app.querySelector("#tsb-custom-ek-fields--tsb");
        if (customFields) {
          customFields.style.display = state.product === "__custom" ? "block" : "none";
        }

        render();
      };

      qty.oninput = e => {
        // ===============================
        // PATCH START: SAFE QUANTITY
        // ===============================
        const val = parseInt(e.target.value);
        state.quantity = Number.isFinite(val) && val >= minimumQuantity
        ? val
        : minimumQuantity;
        // ===============================
        // PATCH END: SAFE QUANTITY
        // ===============================
        render();
      };

      textile.onchange = e => {
        state.textile_color = e.target.value;
        render();
      };

      app.querySelectorAll("[data-pos]").forEach(el => {
        el.oninput = e => {
          state.positions[e.target.dataset.pos] =
            parseInt(e.target.value || 0);
          render();
        };
      });
    }

    bind();
    render();

  });

});